import Update from './models'

export default Update
